import React, { useState, useContext, Fragment, useRef } from "react";
import Buttons from "../../../../lib/ui/buttons/Button";
import "../../../../ui-styles/contentHeading/cancelHeading.css";
import "../../../../ui-styles/list/contactInfoList.css";
import "../../../../ui-styles/list/CardsList.css";
import "../../../../ui-styles/tooltips/tooltips.css";
import "../../../../ui-styles/sliders/RightFullSlider.css";
import { useHistory } from "react-router-dom";
import StripeCheckout from "react-stripe-checkout";

import PatientUploadsSlide from "./PatientUploadsSlide";
import DocAdviceSlide from "./DocAdviceSlide";
import ConfirmCancellation from "../../../../lib/ui/confirmCancellation";
import ExceededCancellation from "../../../../lib/ui/ExceededCancellation";
import Loader from "../../../../lib/ui/loader/Loader";
import { toast } from "react-toastify";

// import Loader from "../../../lib/ui/loader/Loader";
import { CustomCtx, LangCtx } from "../../../../lib/context";
import { dateFormat, getAge, getExperience, timeFormat } from "../../../../lib/functions";
import { cancelAppt, postPaidAppointment } from "../../../../actions/appointment";
import PrescriptionSlide from "../../../conference/components/PrescriptionSlide";
// import { changeApptStatus } from "../../../../actions/schedule";
// import config from "../../../../config.json";
// import { tr } from "date-fns/locale";
// import { getDegree, getDepartmentList, getSpecialization } from "../../../../actions/configuration";
import { useSelector } from "react-redux";

const AppointmentItem = (props) => {
    const history = useHistory();
    const { l, currencyCode } = useContext(LangCtx);
    const [loading, setLoading] = useState(false);
    const appUploads = props.data.uploads && props.data.uploads.length > 0 ? props.data.uploads : [];
    const [uploads, setUploads] = useState(false);
    const [docPscptn, setDocPscptn] = useState(false);
    const [docAdvice, setDocAdvice] = useState(false);
    const [openCfm, setCfm] = useState(false);
    const [noPayment, setNoPayment] = useState(false);
    const { custom } = useContext(CustomCtx);
    const check_ref = useRef(null);
    const keys = {
        serverstripekey: process.env.REACT_APP_serverstripekey,
        clientstripekey: process.env.REACT_APP_clientstripekey,
    };

    const [hover, setHover] = useState(false);

    // const [docAdviceData, setDocAdviceData] = useState([]);
    const { data, role, type } = props;
    // const [rates, setRates] = useState(null)
    const rates = useSelector((state) => state?.inclinic?.rates);

    const handleHistory = () => {
        history.push(`/conference-settings/${data.appointmentId}`);
        // role === "C" ? history.push(`/patient-waiting-room/${data.appointmentId}`) : history.push(`/waiting-room/${data.appointmentId}`);
    };

    // const askForRefund = async () => {
    //     setLoading(true);

    //     try {
    //         changeApptStatus(data.appointmentId, "pending", data.paymentIntentId, data.clinicId, true)
    //             .then((res) => {
    //                 //  console.log("res === ", res);
    //                 if (res?.status && res?.refundStatus && res.refundStatus === "initiated") {
    //                     toast.success(l.refnd_intiated, {
    //                         position: toast.POSITION.TOP_RIGHT,
    //                     });
    //                     toast.warning(l.may_take_10_days, {
    //                         position: toast.POSITION.TOP_RIGHT,
    //                     });
    //                 }

    //                 setLoading(false);
    //                 props.loadData();
    //             })
    //             .catch((err) => {
    //                 console.log("err === ", err);
    //                 console.log("err === ", err);
    //                 let msg = err?.reponse?.data?.error
    //                     ? err.reponse.data.error
    //                     : err.errorMessage
    //                         ? err.errorMessage
    //                         : l.went_worng_pls_try_again;
    //                 toast.dismiss();
    //                 toast.error(msg, {
    //                     position: toast.POSITION.TOP_RIGHT,
    //                 });
    //                 setLoading(false);
    //             });
    //     } catch (err) { }

    //     // console.log("apointmentdata", data);

    //     props.loadData();
    // };

    const onMouseHover = () => {
        setHover(true);
    };

    const onMouseOut = () => {
        setHover(false);
    };

    const handleUploads = (ucdata) => {
        setUploads(true);
    };
    const handleClose = () => {
        setUploads(false);
    };

    const handlePriscription = () => {
        setDocPscptn(true);
        // setDocAdvice(false);
        // setUploads(false);
    };
    const handleClosePriscription = () => {
        setDocPscptn(false);
    };

    const handleCloseDocAdvice = () => {
        setDocAdvice(false);
    };

    const handleCancel = () => {
        setCfm(true);
    };

    const calculateTime = (dataTemp) => {
        let startTime = new Date(data.startTime);
        let currentTime = new Date();
        let timeDiff = (startTime - currentTime) / 1000 / 3600; // Getting difference in hours
        if (timeDiff < 1) {
            setNoPayment(true);
        } else {
            setNoPayment(false);
        }
    };

    const handleConfirm = () => {
        console.log("data::", data)
        let obj = {
            id: data.appointmentId,
            type: "patient",
            startTime: data.startTime,
            clinicId: data.clinicId,
            // should_refund:(((new Date(data.startTime) - new Date().valueOf()) / 1000) / 60) / 60 < 1 ? false : true,
            //payment_intent: data.paymentIntentId,
            //should_refund:(((data.startTime-new Date().valueOf() )/1000)/60)/60 < 1 ? false :true,
            // payment_intent: data.paymentIntentId,
            refund_amount: data.paid * 0.965,
        };

        if(data?.paymentMode !== 'free'){
            obj['payment_intent'] = data.paymentIntentId
        }

        setLoading(true);

        cancelAppt(obj)
            .then((res) => {
                // console.log("res ==== ", res);
                setCfm(false);
                if (res.status && res.refundStatus && res.refundStatus === "initiated") {
                    toast.success(l.refnd_intiated, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    toast.warning(l.may_take_10_days, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                } else if (res.status){
                    toast.success(l.apptmnt_cancelled, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
                props.loadData();
                setLoading(false);
            })
            .catch((err) => {
                console.log("err ==== ", err);
                toast.error(l.please_try_again, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setLoading(false);
            });
    };

    let f = new Date(data.startTime);
    f.setMinutes(f.getMinutes() - 30);
    let t = new Date(data.endTime);

    const onClose = () => {
        setLoading(false);
    };

    // const uploadFile = async (e) => {
    //     try {
    //         setLoading(true);

    //         let accepted_types = [
    //             "image/jpeg",
    //             "image/jpg",
    //             "image/png",
    //             ".doc",
    //             ".docx",
    //             ".pdf",
    //             ".xls",
    //             ".xlsx",
    //             "application/msword",
    //             "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    //             ".ppt",
    //             ".pptx",
    //             "application/vnd.ms-excel",
    //             "image/webp",
    //             "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //             "application/pdf",
    //             "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    //             "video/mp4",
    //             // "video/mp3",
    //             "application/zip",
    //             "application/x-zip-compressed",
    //             // "audio/mpeg"
    //         ];
    //         if (e.target.files.length > 0) {
    //             const files = e.target.files[0];

    //             // console.log("file type", files, files.type, files.size);

    //             if (accepted_types.includes(files.type)) {

    //                 // console.log("file size is==== ", files.size / (1024 * 1024));

    //                 if (files.size / (1024 * 1024) <= 15) {

    //                     // console.log("file type", files, files.type, files.size);

    //                     let filename = "appointments/" + new Date().valueOf() + files.name;

    //                     let body = {
    //                         uploadtype: files.type,
    //                         size: files.size,
    //                         date: files.lastModified,
    //                         uploadname: files?.name,
    //                     };

    //                     const formData = new FormData();
    //                     formData.append("file", files);
    //                     // console.log("form data===", formData);
    //                     let params = {
    //                         bucket: process.env.REACT_APP_s3,
    //                         fileName: filename,
    //                         region: process.env.REACT_APP_s3Region,
    //                     };

    //                     let s3UploadRes = await scan(formData, params);

    //                     if (s3UploadRes && s3UploadRes.status) {
    //                         s3UploadRes = s3UploadRes.data;
    //                         setLoading(false);
    //                         body = {
    //                             ...body,
    //                             url: `https://${process.env.REACT_APP_s3}.s3-${process.env.REACT_APP_s3Region}.amazonaws.com/${s3UploadRes.key ? s3UploadRes.key : filename
    //                                 }`,
    //                             uploadkey: s3UploadRes.key,
    //                         };

    //                         let item = {
    //                             id: data.appointmentId,
    //                             upload: body,
    //                         };

    //                         let getAppointment = await pastAppUploads(item);
    //                         if (getAppointment.status) {
    //                             setAppUploads(getAppointment.data.uploads);
    //                         }

    //                         toast.success("File uploaded successfully");

    //                         // console.log("............:)", data);
    //                     } else {
    //                         toast.error(s3UploadRes.error, {
    //                             position: toast.POSITION.TOP_RIGHT,
    //                         });
    //                     }
    //                     setLoading(false);
    //                 } else {
    //                     setLoading(false);
    //                     toast.error("Upload file size should be less than 15MB");
    //                 }
    //             } else {
    //                 setLoading(false);
    //                 toast.error("Invalid file type", {
    //                     position: toast.POSITION.TOP_RIGHT,
    //                 });
    //             }
    //         }
    //         setLoading(false);
    //     } catch (err) {
    //         console.log("eeeeeeeeeeeeeeeee", err);
    //         setLoading(false);
    //         // return reject(err);
    //         toast.error("Something went wrong, Please try again", {
    //             position: toast.POSITION.TOP_RIGHT,
    //         });
    //     }
    // };

    const handleNext = (token) => {
        if (!loading) {
            setLoading(true);

            let form = {};
            form["appointmentId"] = data?.appointmentId;
            // form['currency'] = data?.currency;
            form["doctorId"] = data?.doctorId;
            // form["patientId"] = role === "C" ? pId : payload.userId; // if clinic pass patientID
            form["patientId"] = data?.patientId;
            // form["clinicId"] = role === "C" ? payload.userId : payload.clinicId; // if clinic pass self id
            form["clinicId"] = data?.clinicId;
            // form["adminId"] = payload.adminId;
            if (process.env.REACT_APP_payment === "true") {
                form["token"] = token;
                // form['serverstripekey'] = keys.serverstripekey
            }
            if (data && data.currency) {
                form["currency"] = currencyCode && role === "P" ? currencyCode.toLowerCase() : data.currency.toLowerCase();
                let curr = data.currency.toLowerCase();
                form["fee"] =
                    currencyCode && role === "P" && data?.doctorData?.consultationFee
                        ? Math.round(data?.doctorData?.consultationFee / (rates ? rates[curr] : 1))
                        : "";
            } else {
                form["currency"] = currencyCode && role === "P" ? currencyCode.toLowerCase() : "inr";
                form["fee"] =
                    currencyCode && role === "P" && data?.doctorData?.consultationFee
                        ? Math.round(data?.doctorData?.consultationFee / (rates ? rates["inr"] : 1))
                        : "";
            }
            setLoading(true);
            postPaidAppointment(form)
                .then((res) => {
                    if (res.status) {
                        toast.success("Payment Successful", {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        props.loadData();
                    } else {
                        console.log("something wrong");
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    console.log("err === ", err);
                    setLoading(false);
                    toast.dismiss();
                    toast.error(err?.response?.data?.error, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                });
        }
    };

    // const getCurrencies = async () => {
    //     try {
    //         let curr = currencyCode.toLowerCase()
    //         getAxios(curr).then((res) => {
    //             console.log("res.data...................:(", JSON.parse(res.data)[curr])
    //             let result = JSON.parse(res.data)[curr]
    //             console.log('res', result);
    //             setRates(result);
    //         }).catch((err) => console.log(err))
    //     }
    //     catch (e) {
    //         console.log('eeeeee', e);
    //     }
    // }

    // useEffect(() => {
    //     if (currencyCode) {
    //         getCurrencies()
    //         console.log("3")
    //     }
    // }, [])

    return (
        <>
            <div className="flGroup" key={data.appointmentId}>
                {loading && <Loader />}
                <div className="flItem">
                    <div className="flDateBlock">
                        <div className="flDayRow">
                            <span className="subHdngTxt current">{dateFormat(data.startTime)}</span>
                        </div>
                        <div className="flTimeRow">
                            <span className="subHdngTxt">
                                {timeFormat(data.startTime)} - {timeFormat(data.endTime)}
                            </span>
                        </div>
                    </div>
                    <div className="rowBlock spaceBtvn">
                        {/* {(data?.refundStatus === 'initiated' && data?.appt_status === 'rejected' && data?.paymentMode === 'prePaid') &&
                                <>
                                     <span className="statusCircle statusPaid"></span>
                                     <span className="statusInfoTxt paidTxt">Refunded</span>
                                </>
                                } */}
                        <div
                            className={
                                data.appt_status === "confirmed"
                                    ? "cnclHndRow"
                                    : data.appt_status === "rejected" || data.appt_status === "cancelled"
                                        ? "cnclCrossIcon"
                                        : "pendingIcon"
                            }
                        >
                            <span
                                className={
                                    data.appt_status === "confirmed"
                                        ? "successTxt"
                                        : data.appt_status === "pending"
                                            ? "pendingTxt"
                                            : "redTxt"
                                }
                            >
                                {l[data.appt_status]}
                            </span>
                        </div>

                        {type === "UA" &&
                            data.appt_status !== "cancelled" &&
                            data.appt_status !== "rejected" &&
                            // data.paymentStatus ==="paid" &&
                            f.valueOf() > new Date().valueOf() && (
                                <Buttons
                                    label={l.cancel}
                                    type="outLine"
                                    size="sm"
                                    onClick={() => {
                                        handleCancel();
                                        calculateTime(data);
                                    }}
                                />
                            )}
                    </div>
                    <div className="flUserInfo">
                        <div className="userList">
                            {/* <div className={data.available ? "availableDot" : "availableDot notAvailable"}></div> */}

                            {data.doctorData && (
                                <Fragment>
                                    <div className="userAvtr">
                                        <img
                                            src={
                                                data.doctorData.profileImage &&
                                                    data.doctorData.profileImage &&
                                                    data.doctorData.profileImage.url
                                                    ? data.doctorData.profileImage.url
                                                    : "/images/icons/doctor-default.png"
                                            }
                                            alt="avatar"
                                        />
                                    </div>
                                    <div className="userDtls">
                                        <span className="userTxtL">{`Dr. ${data.doctorData.name}`}</span>
                                        <span className="userTxtS">
                                            {data.doctorData.qualification ? data.doctorData.qualification : ""}
                                            {data.doctorData.department ? `(${data.doctorData.department})` : ""}{" "}
                                            {data.doctorData.speciality ? `- ${[data.doctorData.speciality]}` : ""}
                                            {data.serviceStartDate ? `- ${getExperience(new Date(data.serviceStartDate))}` : ""}
                                        </span>
                                    </div>
                                </Fragment>
                            )}
                        </div>
                        <div className="cardRowBlock">
                            <div className="flexCol">
                                {/* <span className="paymentStatusLTxt">{l.payment_status} :</span>
                            <div className="paymentStatusIcon">
                                <span className="statusCircle statusPaid"></span>
                                <span className="statusInfoTxt paidTxt">{l[data.paymentStatus]}</span>
                            </div> */}

                                {/* <span className="paymentStatusLTxt">{l.payment_status} :</span>
                            <div className="paymentStatusIcon">
                                <span className="statusCircle statusPending"></span>
                                <span className="statusInfoTxt pendingTxt">{l[data.paymentStatus]}</span>
                            </div> */}

                                {data?.paymentMode === "prePaid" && (
                                    <>
                                        <div className="flexRow">
                                            <div className="flexAutoRow">
                                                <span className="paymentStatusLTxt">{l.payment_status} :</span>
                                            </div>
                                            <div className="flexMinWidthRow">
                                                <div className="paymentStatusIcon">
                                                    {data?.paymentStatus === "paid" ? (
                                                        <>
                                                            {" "}
                                                            <span className="statusCircle statusPaid"></span>
                                                            <span className="statusInfoTxt paidTxt">{l[data?.paymentStatus]}</span>
                                                        </>
                                                    ) : data?.paymentStatus === "open" ||
                                                        data?.paymentStatus === "draft" ||
                                                        data?.paymentStatus === "initiated" ||
                                                        data?.paymentStatus === "pending" ? (
                                                        <>
                                                            {" "}
                                                            <span className="statusCircle statusPending"></span>
                                                            <span className="statusInfoTxt pendingTxt">{l[data.paymentStatus]}</span>
                                                        </>
                                                    ) : data?.paymentStatus === "uncollectible" ||
                                                        data?.paymentStatus === "void" ||
                                                        data?.paymentStatus === "failed" ? (
                                                        <>
                                                            {" "}
                                                            <span className="statusCircle statusFailed"></span>
                                                            <span
                                                                className="statusInfoTxt failedTxt"
                                                                onMouseEnter={onMouseHover}
                                                                onMouseLeave={onMouseOut}
                                                            >
                                                                {l[data?.paymentStatus]}
                                                            </span>
                                                            {/* <span className="statusInfoTxt failedTxt" tooltip = {data.failure_reason  ? data.failure_reason : ""}>{ l[data.paymentStatus]}</span> */}
                                                        </>
                                                    ) : null}
                                                    {/*  PAyment Refunded Status ********/}
                                                    {/* <>
                                 {" "}
                                 <span className="statusCircle"><img src="/images/icons/refund-green.png" alt="icon" /></span>
                                 <span className="statusInfoTxt paidTxt">{l.refunded}</span>
                                </> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flexRow pdngTXS">
                                            {data?.refundStatus && data?.refundStatus === "initiated" && (
                                                <>
                                                    <div className="flexAutoRow">
                                                        <span className="paymentStatusLTxt">{l.refund_Status} &nbsp; : &nbsp;</span>
                                                    </div>
                                                    <div className="flexMinWidthRow">
                                                        <span className="statusInfoTxt paidTxt">{l.refunded}</span>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </>
                                )}

                                {/*** Payment Failed Status ****/}
                                {data && data?.failure_reason && (
                                    <div className="annotationTxt">
                                        <p>{data?.failure_reason}</p>
                                    </div>
                                )}
                            </div>

                            {/* <span className="cardTxtSm">{l.payment_status}: {l[data.paymentStatus]}</span> */}
                        </div>
                    </div>
                    <div className="cardRowBlock">
                        {(data?.paymentMode === "free" || data?.paymentMode === "postPaid") && (
                            <>
                                <span className="paymentStatusLTxt">Payment Mode : &nbsp;</span>

                                <span className="statusInfoTxt paidTxt">
                                    {data?.paymentMode && (data?.paymentMode === "free" ? "Free" : "Post Paid")}
                                </span>
                            </>
                        )}
                    </div>
                    {/* <div className="dtlsBox" onClick={() => handlePriscription(data)}>
                        <img src="/images/icons/visit-details-outline.png" alt="icon" className="invertPrimary" />
                        <span className="dtlsTxt">{l.visitinfo}</span>
                    </div> */}

                    {role === "C" && data.patientData && (
                        <div className="flUserInfo">
                            <div className="subHdgnBox">
                                <span className="subHdngTxt ">{l.pat_details}</span>
                            </div>
                            {/* <div className="cnclHndRow">
                    <span className="redTxt">{l.cancelled}</span>
                </div> */}
                            <div className="userList">
                                <div className="userAvtr">
                                    <img
                                        src={
                                            data.patientData.profileImage &&
                                                data.patientData.profileImage &&
                                                data.patientData.profileImage.url
                                                ? data.patientData.profileImage.url
                                                : "/images/icons/patient-default.png"
                                        }
                                        alt="avatar"
                                    />
                                </div>
                                <div className="userDtls">
                                    <span className="userTxtL">
                                        {data.patientData.title ? data.patientData.title : ""}
                                        {data.patientData.name}
                                    </span>
                                    <span className="userTxtS capitalizeTxt">{`${data.patientData.gender} - ${getAge(
                                        new Date(data.patientData.dob)
                                    )}`}</span>
                                    {/* <span className="userTxtS">{data.patientData.phone}</span> */}
                                </div>
                            </div>
                            <div className="summaryDtls">
                                <span className="subHdngTxt ">
                                    {l.appt_summary}{" "}
                                    <span className="darkTxt">{data.description ? decodeURIComponent(data.description) : ""}</span>
                                </span>
                            </div>
                        </div>
                    )}
                    <div className="btmActionBox">
                        {/* {role === "P" && type === "PA" && (
                            // <div className="dtlsBox">
                            <label htmlFor="fileUpload" className="upldBtn">
                                UPLOAD
                                <input
                                    id="fileUpload"
                                    type="file"
                                    accept="image/*,.doc,.docx,.pdf,.xls,.xlsx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.ppt,.pptx,video/*,.zip"
                                    onChange={uploadFile}
                                />
                            </label>
                            // </div>
                        )} */}
                        {/* <Buttons
                        label={l.doc_advice}
                        type="outLine"
                        size="sm"
                        onClick={() => handleDocAdvice(ucdata)}
                        /> */}
                        {/* {type === "UA" && data.appt_status === "confirmed" && */}
                        {type === "UA" &&
                            role === "P" &&
                            data.appt_status === "confirmed" &&
                            f.valueOf() <= new Date().valueOf() &&
                            t.valueOf() >= new Date().valueOf() && (
                                <Buttons label={l.enter_wtng} type="primary" size="sm" onClick={handleHistory} />
                            )}
                        {/* {type === "UA" && data.appt_status !== "cancelled" && <Buttons
                            label={l.cancel}
                            type="primary"
                            size="sm"
                            onClick={handleCancel}
                        />} */}

                        {!loading &&
                            type === "PA" &&
                            data &&
                            data.paymentMode &&
                            data?.paymentMode === "postPaid" &&
                            data?.paymentStatus !== "paid" &&
                            data?.appt_status === "confirmed" && (
                                <StripeCheckout
                                    name={custom.subDomain}
                                    description="Unified Consultaion" // the pop-in header subtitle
                                    image={custom.logo}
                                    ComponentClass="div"
                                    panelLabel="Pay"
                                    currency={data?.currency}
                                    ref={check_ref}
                                    closed={() => onClose()}
                                    stripeKey={keys.clientstripekey}
                                    token={(token) => handleNext(token)}
                                >
                                    <Buttons label={"Pay"} type="outLine" size="sm" />
                                </StripeCheckout>
                            )}

                        {/* { !loading && type === "PA" && data && data?.appt_status && data?.appt_status === "pending" && (data?.refundStatus === 'initiated') && data?.paymentStatus==="paid" && (
                        <Buttons label={"Refund"} type="outLine" size="sm" onClick = {askForRefund}/>
                        )} */}
                        {type === "PA" && data && data.prescription_status && data.prescription_status === true && (
                            <Buttons label={l.presc} type="outLine" size="sm" onClick={handlePriscription} />
                        )}
                        {appUploads && appUploads.length > 0 && (
                            <Buttons label={l.pat_uploads} type="outLine" size="sm" onClick={handleUploads} />
                        )}
                    </div>
                </div>
                {uploads && <PatientUploadsSlide open={uploads} close={handleClose} data={appUploads} />}
                {docPscptn && <PrescriptionSlide type="view" openSlide={docPscptn} closePresc={handleClosePriscription} data={data} />}
                {/* {docPscptn && <DocPriscriptionSlide docPscptn={docPscptn} close={handleClosePriscription} data={data} />} */}
                {docAdvice && <DocAdviceSlide docAdvice={docAdvice} close={handleCloseDocAdvice} docAdviceData={[]} />}
                {/* {openCfm && (
                <BtmDeleteSlide
                    slideD={openCfm}
                    handleCancel={() => setCfm(false)}
                    txt={l.conf_cancel_appt}
                    oktxt={l.cancel_appt}
                    handleConfirm={handleConfirm}
                />
            )} */}
                {openCfm && noPayment ? (
                    <ExceededCancellation
                        paymentMode={data?.paymentMode}
                        slideC={openCfm}
                        handleCancel={() => setCfm(false)}
                        txt={l.conf_cancel_appt}
                        oktxt={l.cancel_appt}
                        handleCanConfirm={handleConfirm}
                    />
                ) : openCfm && (
                    <ConfirmCancellation
                        slideD={openCfm}
                        paymentMode={data?.paymentMode}
                        handleCancel={() => setCfm(false)}
                        txt={l.conf_cancel_appt}
                        oktxt={l.cancel_appt}
                        handleConfirm={handleConfirm}
                    />
                )}
                {/*** Use it for Confirming cancellation before 1 hr */}
                {/* {openCfm && (
                <ExceededCancellation
                    slideC={openCfm}
                    handleCancel={() => setCfm(false)}
                    txt={l.conf_cancel_appt}
                    oktxt={l.cancel_appt}
                    handleConfirm={handleConfirm}
                />
            )} */}
                {/*** Use it for Confirming cancellation for above popup */}
                {/* {openCfm && (
                <CancelConfirmation
                    openConf={openCfm}
                    handleCancel={() => setCfm(false)}
                    txt={l.conf_cancel_appt}
                    oktxt={l.cancel_appt}
                    handleConfirm={handleConfirm}
                />
            )} */}

                {/* { finalRefundFlag &&  <RefundConf //exceeded
                slideD={finalRefundFlag}
                handleCancel={() => setFinalRefundFlaog(false)}
                txt={l.conf_cancel_appt}
                oktxt={"ok"}
                //handleConfirm={()=>{}
            /> } */}
            </div>
        </>
    );
};

export default React.memo(AppointmentItem);
